/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_TitleInputs */

const en_wc_vs_who_title = /** @type {(inputs: Wc_Vs_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who should use which?`)
};

/**
* | output |
* | --- |
* | "Who should use which?" |
*
* @param {Wc_Vs_Who_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_title = /** @type {((inputs?: Wc_Vs_Who_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_title(inputs)
});
export { wc_vs_who_title as "wc.vs.who_title" }